import { render, staticRenderFns } from "./LockerDeliveries.vue?vue&type=template&id=1475847a&scoped=true"
import script from "./LockerDeliveries.vue?vue&type=script&lang=js"
export * from "./LockerDeliveries.vue?vue&type=script&lang=js"
import style0 from "./LockerDeliveries.vue?vue&type=style&index=0&id=1475847a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475847a",
  null
  
)

export default component.exports